import { usePage } from "@inertiajs/react";
import { useEffect, useState } from "react";

export default function Flash() {
    const { flash } = usePage().props as any;

    const flashType = flash?.notice ? "notice" : flash?.alert ? "alert" : null;
    const payload = flashType ? flash[flashType] : null;

    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (payload) {
            setVisible(true);
        }
    }, [payload?.id]);

    useEffect(() => {
        if (!payload) return;

        const timer = setTimeout(() => {
            setVisible(false);
        }, 2000);

        return () => clearTimeout(timer);
    }, [payload?.id]);

    if (!payload || !visible) return null;

    const bgClass =
        flashType === "notice" ? "bg-green-600" : "bg-red-600";

    return (
        <div
            className={`fixed top-4 right-4 text-white p-3 rounded shadow-lg z-50 ${bgClass}`}
        >
            {payload.message}
        </div>
    );
}
